import script from "./DashboardStartComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardStartComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__